var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-tavern-detail"},[_c('mobile-nav-bar',_vm._b({ref:"mobile-nav-bar",attrs:{"text":_vm.navbarText},on:{"history":_vm.tCloseHandle}},'mobile-nav-bar',_vm.scrollOpt,false)),_vm._v(" "),_c('ldb-detail',{ref:"ldbDetail",attrs:{"theme":"light","detailInfo":_vm.tavernInfo},on:{"update:detailInfo":function($event){_vm.tavernInfo=$event},"tClose":_vm.tCloseHandle}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eac8e2a","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/_mobile/_tavern.vue
// module id = null
// module chunks = 